import axios from "axios";
import { API_URL } from "../env";
import store from "../store/index";
import { getAuth0 } from "../auth";

const client = axios.create({
  baseURL: API_URL,
  timeout: 180000,
});

client.interceptors.request.use(async config => {
  config.headers = config.headers ?? {};
  const auth0 = getAuth0();
  if (auth0) {
    try {
      const token = await auth0.getAccessTokenSilently();
      config.headers["Authorization"] = `Bearer ${token}`;
    } catch {
      // Not authenticated — request proceeds without Bearer token.
    }
  }
  if (!config._skipCompanyId) {
    config.headers["Company-Id"] = store.getters["auth0Store/selectedCompanyId"];
  }
  return config;
});

client.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry && !originalRequest._skipReauthentication) {
      originalRequest._retry = true;
      const auth0 = getAuth0();
      if (auth0) {
        try {
          await auth0.getAccessTokenSilently({ cacheMode: "off" });
          return client(originalRequest);
        } catch {
          const { pathname, search, hash } = window.location;
          await auth0.loginWithRedirect({ appState: { target: pathname + search + hash } });
          return Promise.reject(error);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default client;
